import { FC, useEffect } from 'react';
import ShopifyCart from 'lowcode/common/ShopifyCart';
import styled from './index.module.scss';
import { useMembersStore, useMembersDispatch } from './MembersProvider';
import BuoySubscribe from './FY2024/Teaser/BuoySubscribe';

// import TeaserCompoment from './FY2024/Teaser';
// import ActivityCompoment from './FY2024/ActivityCom';
// import ReturnCompoment from './FY2024/Return';
// import EndCompoment from './FY2024/End';

import TeaserCompoment from './FY2025/Teaser';
import ActivityCompoment from './FY2025/Activity';

import { IPageStatus } from './type';
import EfScrollAni from '@/efscrollani';
import { useLang } from '@/app/utils/useLang';
import { getCampaignInfo } from './apis';
import { getCurrentPlan } from '@/service/referral';
import { checkBlacklist } from '@/service/vip';
import getLocal from '@/app/utils/getLocal';
import { message } from 'antd-v5';

const MembersCompoment: FC = ({}) => {
    // const { useLang, useRouter, isApp } = useGlobal();
    const { pageStatus } = useMembersStore();
    const { t } = useLang('membersday');
    const { locale, pathname } = getLocal();
    const dispatch = useMembersDispatch();

    const initCampaign = () => {
        const path = `/${locale}${pathname}`;
        // 获取Campaign信息
        getCampaignInfo(locale, path).then((res) => {
            if (res.code !== '0') return message.error(res.message);
            dispatch({
                type: 'changeCampaignInfo',
                payload: res.data,
            });
        });
        // 获取黑名单
        checkBlacklist(locale).then((res) => {
            if (res.code !== '0') return message.error(res.message);
            dispatch({
                type: 'changeInBlackList',
                payload: res.data.inBlackList,
            });
        });
        // 获取裂变信息
        getCurrentPlan(locale, path).then((res) => {
            if (res.code !== '0') return message.error(res.message);
            dispatch({
                type: 'changeReferralInfo',
                payload: res.data,
            });
        });
    };

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        initCampaign();
        if (typeof window !== 'undefined' && window.AniContainer) {
            return () => AniContainer.destroy();
        }
    }, []);

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                    .glo-editor-modal-show {
                        z-index: 2103;
                    }
                    body::-webkit-scrollbar {
                        width: 6px;
                    }
                    body::-webkit-scrollbar-track {
                        background-color: #000;
                    }
                    body::-webkit-scrollbar-thumb {
                        border-radius: 3px;
                        background-color: #d5d5d5;
                    }
                `}
            </style>
            <div className={`${styled.MembersFestival}`}>
                <BuoySubscribe isShowIcon={false} />
                {pageStatus === IPageStatus.TEASER && <TeaserCompoment />}
                {pageStatus === IPageStatus.ACTIVITY && <ActivityCompoment />}
            </div>
            <ShopifyCart />
        </>
    );
};

export default MembersCompoment;
